import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ComparisonTable } from "../../../tables/tables";
import { InventoryItem } from "../../models/inventory-item.model";
import { formatListingUsd, machineRentToOwnOption, rentToOwnRentalCredit } from "../../machine-listing-price";

@Component({
  selector: "common-machine-rpo-table",
  templateUrl: "./machine-rpo-table.component.html",
  styleUrls: ["./machine-rpo-table.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MachineRpoTableComponent implements OnInit {
  @Input() machine: InventoryItem;
  @Input() fontClass = "";
  comparisonTable: ComparisonTable;

  ngOnInit(): void {
    const option = machineRentToOwnOption(this.machine);
    const optionLabel = option.onRequest ? "Price on Request" : option.price != null ? formatListingUsd(option.price) : "";
    const credit3 = rentToOwnRentalCredit(this.machine?.rentalRate, 3);
    const credit6 = rentToOwnRentalCredit(this.machine?.rentalRate, 6);
    const starting = option.price ?? 0;
    const adjustedPrice3 = Math.max(0, starting - credit3);
    const adjustedPrice6 = Math.max(0, starting - credit6);
    const purchaseLabel = option.price != null ? (amount: number) => formatListingUsd(amount) : () => optionLabel;

    this.comparisonTable = {
      headers: [],
      rows: [
        {
          columns: [{ label: "<b>Rental Duration</b>" }, { label: "<b>3 Mos</b>" }, { label: "<b>6 Mos</b>" }],
        },
        {
          columns: [{ label: "Option Price" }, { label: optionLabel }, { label: optionLabel }],
        },
        {
          columns: [
            { label: "Rental Credit" },
            { label: `<span class="badge badge-pill badge-success p-1 font-weight-light">${formatListingUsd(credit3)}</span>` },
            { label: `<span class="badge badge-pill badge-success p-1 font-weight-light">${formatListingUsd(credit6)}</span>` },
          ],
        },
        {
          columns: [
            { label: "<b>Purchase Price*</b>" },
            { label: purchaseLabel(adjustedPrice3) },
            { label: purchaseLabel(adjustedPrice6) },
          ],
        },
      ],
    };
  }
}
